export default {
  beheardReport: {
    reportBeingGenerated: 'Tu informe #BeHeard se está generando...',
    title: {
      report: 'Informe #BeHeard {type}',
      premium: 'Premium',
      free: 'Gratis',
    },
    shortTermQuestion:
      'Las probabilidades de dejar mi trabajo voluntariamente durante el próximo año son extremadamente bajas.',
    longTermQuestion:
      'Siento que tendré una larga carrera en esta organización.',
    sectionTitles: {
      overview: 'VISIÓN GENERAL',
      characteristics: 'CARACTERÍSTICAS',
      participation: 'PARTICIPACIÓN',
      results: 'RESULTADOS',
      topFiveRecommendations: 'LAS 5 PRINCIPALES RECOMENDACIONES',
      employeeTurnoverForecast: 'PRONÓSTICO DE ROTACIÓN DE EMPLEADOS',
      comparisonGraphs: 'GRÁFICOS COMPARATIVOS',
      fullReport: 'INFORME COMPLETO',
      customQuestions: 'PREGUNTAS PERSONALIZADAS',
    },
    navigationTitles: {
      overview: 'Visión General',
      characteristics: 'Características',
      results: 'Resultados',
      topFiveRecommendations: 'Las 5 Principales Recomendaciones',
      employeeTurnoverForecast: 'Rotación',
      comparisonGraphs: 'Gráficos Comparativos',
      fullReport: 'Informe Completo',
      customQuestions: 'Preguntas Personalizadas',
    },
    overview: {
      overviewDescription:
        'Tu informe #BeHeard Premium proporciona mucho más que un puntaje de compromiso de los empleados. Ofrece hallazgos clave sobre el grado en que tus empleados se sienten apasionados por sus trabajos, están comprometidos con tu organización, realizan esfuerzos discrecionales en su trabajo y están dispuestos a referir. Esto se debe a que el compromiso de los empleados se relaciona directamente con la productividad, los ingresos, el ausentismo, la rotación, la satisfacción del cliente y otros aspectos de la organización. Además de tu puntaje general de compromiso de los empleados, este informe ofrece resultados sobre cinco factores de compromiso, pronostica la rotación a corto y largo plazo, y ofrece recomendaciones personalizadas para aumentar el compromiso.',
    },
    characteristics: {
      description:
        'Antes de profundizar en los resultados, comencemos observando las características clave de los empleados comprometidos y no comprometidos. ¡Por eso es importante tomar medidas para fomentar el compromiso de los empleados!',
      engagedEmployees: { title: 'Empleados Comprometidos' },
      disengagedEmployees: { title: 'Empleados No Comprometidos' },
    },
    participation: {
      overallRate: 'Tasa General',
      description:
        'Haz clic en cada filtro demográfico a continuación para ver tasas de participación específicas.',
      noParticipation: 'Vuelve más tarde, nadie ha participado todavía.',
      demographicsWithLessThanFiveParticipants:
        'Los datos demográficos con menos de 5 participantes para un valor en particular mostrarán N/A. (por ejemplo, 4 participantes en el Departamento de TI mostrarán N/A)',
    },
    results: {
      description:
        'Esta sección proporciona un resumen de tus resultados de compromiso, incluidos las 5 principales áreas de acción, las 5 principales fortalezas y los 5 elementos más importantes para tus empleados.',
      engagementScore: { engagement: 'Compromiso', score: 'Puntaje' },
      engagementDriversHeader: 'Puntajes de los Factores de Compromiso',
      effectiveness: 'EFECTIVIDAD',
    },
    progressBarLegend: {
      legendTitle: 'Leyenda del Puntaje de Efectividad',
      colorMeaning: {
        negative: 'Desfavorable',
        neutral: 'Neutral',
        positive: 'Favorable',
      },
    },
    driverScore: {
      alignment:
        'El grado en que los empleados creen y se esfuerzan por los valores, metas y misión de esta organización.',
      engagement:
        'El grado en que los empleados se sienten apasionados por sus trabajos, están comprometidos con nuestra organización, realizan esfuerzos discrecionales en su trabajo y están dispuestos a referir.',
      fit: 'El grado en que los empleados sienten que están en los trabajos correctos y tienen las habilidades, conocimientos y capacidades necesarias para desempeñarse adecuadamente en sus roles.',
      growth:
        'El grado en que los empleados sienten que reciben apoyo para avanzar en sus carreras o desarrollar habilidades personales dentro de esta organización.',
      team: 'El grado en que esta organización fomenta un estilo de trabajo basado en equipos (es decir, departamentos o grupos trabajan bien juntos).',
      valuing: 'El grado en que los empleados se sienten valorados por esta organización.',
      custom_ratings_questions: 'Preguntas de Calificación Personalizadas',
    },
    topFiveText: {
      action: {
        title: 'Las 5 Principales Áreas de Acción',
        description:
          'Tus empleados calificaron las siguientes declaraciones como bajas en efectividad y altas en importancia (es decir, estos elementos tienen la mayor brecha de ROI). Obtendrás el mayor retorno de inversión si enfocas tus esfuerzos de compromiso en estas cinco áreas (enumeradas en orden de prioridad).',
      },
      strength: {
        title: 'Las 5 Principales Fortalezas',
        description:
          'Tus empleados calificaron las siguientes declaraciones como altas en efectividad y altas en importancia (es decir, estos elementos tienen la menor brecha de ROI). Usa estos datos para promover tu marca de empleado en estrategias de atracción, compromiso y retención de talento. ¡Estas son tus mayores fortalezas!',
      },
      importance: {
        title: 'Los 5 Elementos Más Importantes',
        description:
          'Tus empleados clasificaron las siguientes cinco declaraciones como las más importantes para ellos.',
      },
      topFiveResultDetails: {
        effectiveness: 'Efectividad',
        importance: 'Importancia',
        previousEffectiveness: 'Efectividad Anterior',
        benchmarkEffectiveness: 'Efectividad de Referencia',
      },
      topFiveRecommendations: {
        description:
          'Estas recomendaciones accionables se basan en tus 5 principales áreas de acción. Aquí es donde tus esfuerzos para aumentar el compromiso te darán el mayor retorno de inversión. ¡Es hora de actuar!',
        noRecommendations:
          'No hay recomendaciones para los resultados mostrados.',
      },
      tooltip: { roiGap: 'Diferencia entre efectividad e importancia' },
    },
    filterButtons: { filters: 'Filtros', download: 'Descargar' },
    downloadMenu: {
      pdfNewTab: 'Abrir en nueva pestaña (PDF)',
      pdfDownload: 'PDF',
      xlsxDownload: 'Hoja de Cálculo (.xlsx)',
    },
    noData: 'No hay {title} para los resultados mostrados.',
    turnoverOverviewDescription:
      'La probabilidad de que los empleados dejen tu organización dentro de los próximos doce meses.',
    turnoverForecast: {
      statement: 'DECLARACIÓN',
      atRisk: 'En Riesgo',
      passive: 'Pasivo',
      committed: 'Comprometido',
      employee: 'empleado',
      employees: 'empleados',
      potentialTurnover: 'Rotación Potencial',
      previousTurnover: 'Rotación Anterior',
      description:
        'Tu perspectiva a corto y largo plazo se predice usando las respuestas de tus empleados a las declaraciones de rotación en la encuesta.',
      shortTerm: 'Perspectiva a Corto Plazo',
      longTerm: 'Perspectiva a Largo Plazo',
    },
    comparisonGraphs: {
      description:
        'Ahora es momento de observar más de cerca los resultados de compromiso en toda la organización. Simplemente pasa el cursor sobre los gráficos de barras para ver resultados específicos. Dependiendo de tus configuraciones de permisos, puedes usar Filtros para cambiar los gráficos comparativos.',
      demographic: 'Demográfico',
      legend: {
        engaged: 'Comprometidos',
        neutrals: 'Neutrales',
        disengaged: 'No Comprometidos',
      },
    },
    fullReport: {
      engagementScore: 'Puntaje de Compromiso',
      participationRate: 'Tasa de Participación',
      legend: {
        strengths: 'Fortalezas',
        recommendedActionAreas: 'Áreas de Acción Recomendadas',
      },
      tableHeaders: {
        score: 'Puntaje',
        result: 'Resultado',
        effectiveness: 'Efectividad',
        importance: 'Importancia',
        previousEffectiveness: 'Efectividad Ant.',
        benchmark: 'Referencia',
      },
      tableData: { viewRecommendations: 'Ver recomendaciones aquí' },
      openEndedQuestions: 'Preguntas Abiertas',
      noCustomRatingQuestions:
        'No se usaron preguntas de calificación personalizadas en esta encuesta.',
      noCustomOpenEndedQuestions:
        'No se usaron preguntas abiertas personalizadas en esta encuesta.',
      buttonLabels: {
        xlsx: 'Descargar respuestas como XLSX',
        pdf: 'Descargar respuestas como PDF',
      },
    },
    unlockPremiumReport: 'HAZ CLIC AQUÍ PARA DESBLOQUEAR EL INFORME PREMIUM',
    snackbar: {
      success: {
        surveyAddedToCart: 'Encuesta añadida a tu carrito con éxito',
        filters: '¡Tus filtros se han aplicado!',
      },
    },
  },
  report: {
    upgradeReport: 'Actualizar Informe',
    freeReport: 'Informe Gratuito',
    premiumReport: 'Informe Premium',
    shareReport: 'Compartir Informe',
  },
  survey: {
    actions: {
      clone: 'Clonar Encuesta',
      preview: 'Vista Previa de la Encusta',
      archive: 'Archivar Encuesta',
    },
    status: {
      scheduled: 'Programado',
      open: 'Abierto',
      closed: 'Cerrado',
      awaitingManualOpening: 'Esperando Lanzamiento Manual',
    },
    snackbar: {
      success: {
        alreadyFinished: 'Ya terminaste esta encuesta',
        finishedSurvey:
          '¡Terminaste la encuesta! Gracias por tomarse el tiempo',
        giftCardRedeemed:
          '¡Tarjeta de regalo canjeada con éxito! Esté atento a un correo electrónico con el enlace de su tarjeta de regalo electrónica.',
      },
    },
  },
  surveyKey: {
    status: {
      surveykey: 'Survey key',
      paragraph1:
        'La encuesta utiliza Caras y Estrellas para la calificación.  Califique su experiencia en el lugar de trabajo y lo importante que es para cada declaración. La satisfacción se basa en las caras y la importancia se basa en las estrellas del 1 al 5. ',
      paragraph2: 'Califique su experiencia sobre el uso de nuestro producto.',
      title1: 'Satisfaction',
      title2: 'Importance',
    },
  },
  surveyinstruction: {
    surveyinstructionkey: 'Survey Instructions',
    surveytitle: ' This survey has a',
    twopart: 'two-part rating process',
    using: 'for each statement using',
    faces: 'Faces',
    and: 'and',
    star: 'Stars.',
    rate: 'Rate how much you',
    agree: 'agree or disagree',
    statement: 'with each statement using the',
    then: 'and then',
    how: 'how',
    important: 'important',
    eachstatement: 'each statement is to you in the workplace using a',
    starrating: '5-star rating',
    scale: 'scale.',
  },
  surveyDialogs: {
    title: 'Encuestas',
    addSurvey: {
      descriptionFirstLine:
        'It’s time to make the survey your own. First, select your launch timeline below to get started. You can make changes before the survey opens and extend the survey before it closes. Click',
      link: 'HERE',
      descriptionSecondLine:
        'for best practices to launch and market the survey.',
    },
    editSurvey: {
      description:
        'Need to edit your survey? No problem. You can do that here. Please make your changes below.',
    },
    extendSurvey: { title: 'Extend Survey', closeDate: 'Close Date' },
    confirmClose: {
      title: 'Close Survey',
      actionLabel: 'Close Survey',
      close: 'close',
    },
    confirmDelete: { title: 'Remove Survey', actionLabel: 'Delete Survey' },
    formLabels: {
      surveyName: 'Survey Name',
      launchDate: 'Launch Date',
      closeDate: 'Close Date',
      allowReward: 'Reward survey participation with a Gift Card',
      allowRewardTooltip:
        'Los empleados podrán seleccionar su tarjeta de regalo directamente desde nuestro sistema después de participar.',
      allowAnswersToBeUpdated:
        'Give employees permission to edit their survey responses',
      allowAnswersToBeUpdatedTooltip:
        'Las ediciones solo se pueden realizar cuando la encuesta está abierta',
      rewardAmount: 'Gift Card Amount',
    },
    customizedQuestions: {
      header: 'Add Custom Questions/Statements',
      description:
        'In addition to the 38 questions in our statistically valid #BeHeard engagement survey, you can add up to five 5-star rating questions and five open ended questions. If you want some ideas for your custom questions, check out examples',
      link: 'HERE',
      statement: 'Statement',
      statementPlaceholder: 'Type your question/statement...',
      fiveStarQuestions: { header: '5-Star Rating Questions' },
      openEndedQuestions: { header: 'Open-Ended Questions' },
    },
  },
  surveyLanding: {
    welcomeToSparck: 'Bienvenido a Sparck!',
    areYouReady:
      '¿Está listo para participar en la encuesta {beheard} y ser escuchado?',
    thankYou: 'Gracias por dejar que se escuche su voz.',
    noActiveSurveys:
      'No hay ninguna encuesta activa que completar en este momento, pero nos alegra que se haya registrado.',
    whatBeHeardSurveyIs:
      'La encuesta #BeHeard es una encuesta anónima diseñada para ser un lugar seguro para compartir sus comentarios sobre el lugar de trabajo. Su organización se preocupa por lo que usted piensa y quiere darle una voz confidencial para hablar libremente, ¡por eso se asoció con Sparck! Solo se compartirán los resultados agregados al final para ayudar a dar forma a las estrategias organizativas que avanzan en función de las áreas que más significan para usted y sus colegas.',
    youAreAwesome:
      '¡Usted es LO MÁXIMO! Gracias por tomarse el tiempo necesario para participar en la encuesta #BeHeard y ser escuchado. Sus comentarios y opiniones no tienen precio.',
    feedbackImportance:
      "Your feedback is really important to us, so we'll send you an email as soon as a new survey is posted!",
    eachItemExplanation:
      'La encuesta solo tomará unos 10 minutos en completarse. Cada elemento tendrá dos partes: primero, calificará en qué medida está de acuerdo o en desacuerdo con cada declaración del lugar de trabajo eligiendo una de las caras. Una vez que lo haya hecho, calificará la importancia de cada afirmación para usted utilizando las estrellas. ¡Mira el ejemplo!',
    iAmReady: 'Estoy listo para empezar',
    updateMyAnswers: 'Revisa mis respuestas!',
    surveyPagination: { previous: 'Anterior', nextPage: 'Siguiente Página' },
    submitSurvey: 'Enviar Encuesta',
    pendingGiftCards: 'Tienes {count} tarjetas de regalo pendientes! 🎉',
    pendingGiftCardLabel: '{rewardValue} para {surveyName}',
    redeem: 'Canjear',
    giftCardRedeemed: '¡Tarjeta de regalo canjeada con éxito!',
    departmentTerm: 'Departamento',
    departmentValue: ' ',
    missionAndValueTerm: 'Misión y valores',
    missionAndValueText:
      'Estamos construyendo algo especial, centrados en ofrecer los mejores resultados para nuestros clientes mediante una integración y automatización inteligentes',
    missionAndValueValue: 'Valores: Sé aliente. Sé tú mismo. Sé Boomi.',
    managerTerm: 'Gerente',
    managerValue: 'Tu líder directo al 8 de junio de 2023',
    seniorLeadershipTeamTerm: 'Equipo de liderazgo sénior ',
    seniorLeadershipTeamValue: 'Equipo de liderazgo ejecutivo',
    surveyInstructionsTitle: 'Survey Instructions',
    surveyInstructionsContent:
      'This survey has a two-part rating process for each statement using Faces  and Stars.  Rate how much you agree or disagree with each statement using the faces and then how important each statement is to you in the workplace using a 5-star rating scale.',
    boomiSurveyLandingContent:
      'La encuesta #BeHeard es una encuesta anónima diseñada para ser un lugar seguro para usted a fin de compartir sus comentarios y opiniones acerca de su experiencia en Boomi.  ¡Boomi se preocupa por su opinión y quiere brindarle una voz confidencial para que hable con libertad, razón por la que estamos trabajando conjuntamente con Sparck! Únicamente se compartirán los resultados totales al final, para ayudar a dar forma a estrategias organizativas de cara al futuro en las áreas de mayor importancia para usted y sus colegas en Boomi. Antes de comenzar, he aquí algunas definiciones para referencia de todos los participantes:',
    boomiSurveyLandingContentTiming:
      'Sólo se necesitan 15 minutos para completar la encuesta. Cada artículo tendrá dos partes: primero, usted calificará en qué medida está de acuerdo o en desacuerdo con cada declaración relacionada con el centro de trabajo eligiendo una de las caras. Una vez que lo haya hecho, calificará cuán importante es cada declaración para usted utilizando las estrellas. ¡Compruebe el ejemplo animado! ',
    topicCards: {
      secure: {
        title: 'Tus Datos estan {keyword}',
        keyword: 'Seguros',
        description:
          'Nos tomamos muy en serio la protección de datos. Sparck utiliza un conjunto de tecnologías y protocolos que previenen las fugas de datos y los ciberataques.',
      },
      anonymous: {
        title: 'Tu Participación es {keyword}',
        keyword: 'Anónima',
        description:
          '¡La confidencialidad es muy importante para nosotros! Su organización o gerente nunca podrá ver sus respuestas individuales. Los datos que proporcionamos son estrictamente anónimos.',
      },
      giftCard: {
        title: 'Esta Encuesta Tiene un {keyword}!',
        keyword: 'Tarjeta de Regalo',
        description:
          '¡Eso es correcto! Como "Gracias" por completar la encuesta, su organización le ofrece una tarjeta de regalo de su elección. Puedes canjearlo al final. ¡Disfrutar!',
      },
      answersUpdate: {
        title: '{keyword} Tus Respuestas',
        keyword: 'Actualize',
        description:
          '¡Una gran noticia! Puede volver para actualizar y editar sus respuestas en cualquier momento mientras la encuesta aún esté abierta. ¡Vuelve a iniciar sesión!',
      },
    },
  },
  surveyOverview: {
    snackbarSuccess: {
      openSurvey: 'The survey is now open!',
      extendedSurvey: 'The survey close date has been extended successfully!',
      closedSurvey: 'The survey has been closed!',
      deletedSurvey: 'The survey has been archived!',
      employeesInvited: 'Employees have been invited successfully!',
      addedToCart: 'Survey added to your cart successfully',
      randomParticipationsCreated:
        'Random participation completion queued successfully!',
      randomParticipationsJob:
        'Background job submitted (ID: {jobId}).',
    },
    selectLabel: 'Encuesta',
    minimumNumberOfEmployees:
      'Your organization must have at least 5 employees to create a new survey.',
    whenSurveyCloses:
      'When your survey closes the #BeHeard results will be immediately available.',
    scheduledLaunchSurveyInfo:
      "Your survey isn't live yet.  It will Launch Automatically on {launchDate}. If you would like to launch it manually you can click the Launch Survey button or edit your survey to launch manually.",
    manualLaunchSurveyInfo:
      "Your survey isn't live yet and it is set to Launch Manually. When you are ready to Launch your survey, click the Launch Survey button.",
    newSurvey: 'New Survey',
    launchSurvey: 'Launch Survey',
    editSurvey: 'Edit Survey',
    extendSurvey: 'Extend Survey',
    closeSurvey: 'Close Survey',
    createRandomParticipations: 'Create Random Participations',
    applyUpgrade: 'Apply Upgrade',
    printSurvey: 'Print',
    applyDowngrade: 'Apply Downgrade',
    inviteEmployees: 'Invite Employees',
    deleteSurvey: 'Archive Survey',
    createRandomParticipationsDescription:
      'This will automatically create random participations for the selected survey. Please confirm the survey information and enter the required details to continue.',
    createRandomParticipationsCompany:
      'Company: {name} ({id})',
    createRandomParticipationsSurvey: 'Survey: {name} ({id})',
    createRandomParticipationsCountLabel: 'Participations to create',
    createRandomParticipationsCountHelper:
      'Enter a number between 1 and {max}.',
    createRandomParticipationsSecurityLabel:
      'Security pass (company_id + survey_id)',
    createRandomParticipationsSecurityHelper:
      'Type {pass} to confirm this action.',
    createRandomParticipationsSecurityMissing:
      'Unable to validate the security pass. Company or survey information is missing.',
    createRandomParticipationsAction: 'Create Participations',
    createRandomParticipationsCompanyLabel: 'Company',
    createRandomParticipationsCompanyId: 'ID: {id}',
    createRandomParticipationsSurveyLabel: 'Survey',
    createRandomParticipationsSurveyId: 'ID: {id}',
    anticipatedTurnover: 'Anticipated Turnover more than 12 Months Away',
    overallParticipation: 'Overall Participation Rate',
    person: 'Person',
    people: 'People',
    employeesInvitation: {
      inviteEmployees: 'Invite Employees',
      chooseEmployees: 'Choose below the employees you want to invite for',
      textFieldLabel: 'Choose one or more employees',
      cancelButton: 'Cancel',
      inviteButton: 'Invite Employees',
    },
    tabs: {
      labels: { general: 'General', sharedReports: 'Informes Compartidos' },
    },
    validations: {
      surveyNameIsRequired: 'Survey Name is required',
      minimumLaunchDate: 'You cannot select a past date',
      maximumLaunchDate: 'Launch Date cannot be after the Close Date',
      launchDateIsRequired: 'Launch Date is required',
      minimumCloseDate: 'Close Date cannot be before Launch Date',
      closeDateIsRequired: 'Close Date is required',
      rewardAmountIsRequired: 'Gift Card amount is required',
    },
  },
  surveyProgress: {
    bulletLabels: {
      createdOn: 'Created on',
      openOn: 'Open on',
      closedOn: 'Closed on',
      willCloseOn: 'Will Close on',
    },
  },
  ratingSection: {
    toWhatExtent:
      '¿En qué medida está de acuerdo o en desacuerdo con esta afirmación?',
    important: 'Esto es importante para mí.',
    ratingLabels: {
      stronglyDisagree: 'Totalmente En Desacuerdo',
      disagree: 'En Desacuerdo',
      neutral: 'Neutro',
      agree: 'De Acuerdo',
      stronglyAgree: 'Totalmente de acuerdo',
      notApplicable: 'No aplica',
    },
    change: 'Cambiar',
    unansweredItem: 'Please respond to every item before continuing.',
    formLabels: {
      textField: 'Your answer',
      placeholder: 'Type anything you want here...',
      helperText:
        'To ensure your confidentiality, do not put any personally identifiable information.',
    },
  },
  manageShareReport: {
    reportSections: {
      labels: {
        comparisonGraph: 'Comparison Graph',
        results: 'Results',
        topFiveActionAreas: 'Top 5 Action Areas',
        topFiveStrengths: 'Top 5 Strengths',
        topFiveMostImportantItems: 'Top 5 Most Important Items',
        recommendations: 'Recommendations',
        turnoverForecast: 'Employee turnover forecast',
        fullReport: 'Full Report',
        customRatingQuestions: 'Custom Ratings Questions',
        customOpenEndedQuestions: 'Custom Open-Ended Questions',
      },
    },
    previewFor: 'Preview for {name}',
    reportWillBeSharedWithRoles: 'This report will be shared with',
    formHandler: {
      title: 'Compartir Informe',
      labels: {
        name: 'Nombre del Informe Compartido',
        expirationDate: '¿Cuánto tiempo estará disponible?',
        whatToSee: '¿Qué pueden ver?',
        limitReport: 'Limitar Informe por Datos Demográphicos',
        whichRoles: 'Which Roles can see this Share Report?',
        roles: 'Roles',
        whichDemographics: 'Which Demographics will receive this Share Report?',
      },
      placeholders: { beheardReport: '#BeHeard ShareReport 001' },
      dialog: {
        title: 'Warning!',
        content: {
          firstLine:
            '¿Está seguro de que desea dar acceso a las respuestas de su empleado?',
          secondLine:
            'Las respuestas contienen información muy sensible. Asegúrese de haber seleccionado los datos demográficos correctos para esta acción.',
        },
        buttonText: '¡Entendí!',
      },
    },
    snackbars: { invitesSent: 'Invitaciones enviadas con éxito' },
  },
  inviteShareReport: {
    dialogTitle: 'Invitaciṍn para Compartir Informe',
    dialogActionLabel: 'Compartir este informe',
    clickToInvite:
      'Se creó su informe compartido, pero debe invitar personas. Haga clic en "Compartir este informe" para enviar correos electrónicos a sus invitados',
  },
  shareReport: {
    title: 'Compartir Informes',
    description:
      'Tú controlas quién tiene acceso a tus informes #BeHeard Premium',
    columnHeaders: {
      sharedReport: 'Nombre del Informe Compartido',
      surveyName: 'Nombre de la Encuesta',
      expires: 'Expira',
    },
    validations: {
      minimumExpirationDate: 'No puede seleccionar una fecha pasada',
      expirationDateIsRequired: 'La fecha de caducidad es obligatoria',
    },
  },
}
